import { CSSObject } from "@emotion/react";
import { constants, mediaQueryStyles } from "@newsela/angelou";

const { mediaQuery: mq } = mediaQueryStyles;
const {
  BreakpointNames: { md },
}: { BreakpointNames: { xs: string; sm: string; md: string } } =
  constants.breakpoints;

export const modalDescriptionCss: CSSObject = {
  position: "relative",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-end",
  margin: "0",
  overflowY: "auto",
  height: "60vh",

  [mq.upTo(md)]: {
    alignItems: "flex-start",
  },
};

export const tabPanelAdjustmentsCss: CSSObject = {
  marginTop: "-48px",
  width: "100%",

  "& > ul": {
    position: "sticky",
    top: 0,
    left: 0,
    backgroundColor: constants.colors.ui.white[50],
    paddingBottom: "8px",
  },

  [mq.upTo(md)]: {
    marginTop: 0,
  },
};
